// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"_2BfTvG1IFbbafjjBiVMZcS","cancelBtn":"_3ncHTH6gbrTRxzj2R_agt_","saveBtn":"_132P0F3lncA_m9i_GvOoo-"};